export const ConstantsSkeleton = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 py-10 px-32">
            {[1, 2, 3].map((i) => (
                <div key={i} className="animate-pulse bg-white rounded-xl p-4 shadow-lg">
                    <div className="flex justify-between mb-4">
                        <div className="h-6 bg-gray-200 rounded-full w-32"></div>
                        <div className="h-6 bg-gray-200 rounded-full w-16"></div>
                    </div>
                    <div className="space-y-3">
                        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                    </div>
                    <div className="flex gap-2 mt-4">
                        <div className="h-8 bg-gray-200 rounded-lg w-3/4"></div>
                        <div className="h-8 bg-gray-200 rounded-lg w-1/4"></div>
                    </div>
                </div>
            ))}
        </div>
    );
};